export enum ApplicationStatus {
  DRAFT = 'DRAFT',
  PRECHECK_PENDING = 'PRECHECK_PENDING',
  PRECHECK_FAILED = 'PRECHECK_FAILED',
  PRECHECK_APPROVED = 'PRECHECK_APPROVED',
  RULES_ENGINE_PENDING = 'RULES_ENGINE_PENDING',
  RULES_ENGINE_COMPLETE = 'RULES_ENGINE_COMPLETE',
  APPROVED = 'APPROVED',
}
